import {
	SET_CREWS,
	SET_CREW,
	CLEAR_CREWS,
	CLEAR_CREW,
	ADD_CREW,
	UPDATE_CREW,
	REMOVE_CREW,
} from './actionTypes';

export const crew = (state = {}, action) => {
	switch (action.type) {
		case SET_CREW:
			return action.payload;
		case UPDATE_CREW:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CREW:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CREWS:
			return action.payload;
		case ADD_CREW:
			return [...state, action.payload];
		case UPDATE_CREW:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CREW:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CREWS:
			return [];
		default:
			return state;
	}
};
